module.exports = __webpack_public_path__ + "static/isha-d09037c922a0cebed3c928707e492d15.png";